<template>
  <div id="login">
    <form class="form-group" v-if="!logged">
      <div class="input-group">
        <span class="input-group-text">
          <i class="fa fa-user"></i>
        </span>
        <input type="text" v-model="user" class="form-control" :placeholder="$i18n.t('login.user')" />
      </div>
      <div class="input-group">
        <span class="input-group-text">
          <i class="fa fa-key"></i>
        </span>
        <input
          type="password"
          v-model="pass"
          class="form-control"
          :placeholder="$i18n.t('login.pass')"
        />
      </div>
      <button type="submit" v-on:click.prevent="verificar" class="btn btn-primary">Ingresar</button>
    </form>
    <div class="loading" v-if="loading">
      <div class="lds-spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div
      id="empresas"
      class="form-group"
      v-if="logged && (empresa.length > 1)"
      v-bind:class="{blur:loading}"
    >
      <select v-model="empid" class="w3-select w3-border" v-bind:disabled="loading">
        <option
          v-for="(emp,index) in empresa"
          v-bind:key="index"
          :value="emp.empId"
        >{{emp.razonSocial}}</option>
      </select>
      <button
        v-bind:disabled="loading"
        @click="seleccionar"
        class="btn btn-success"
      >{{$i18n.t('login.button.seleccionar')}}</button>
    </div>
  </div>
</template>
<script>
import md5 from "md5";
import notify from "devextreme/ui/notify";
// import ws from "../config.json";
export default {
  name: "login",
  data() {
    return {
      user: "",
      pass: "",
      empresa: {},
      empid: 0,
      logged: false,
      loading: false,
      empresasHabilitadas: []
    };
  },
  methods: {
    async verificar() {
      await this.axios
        .post(this.$store.getters.ws.api_paljet + "/usuarios/verificar", {
          user: this.user,
          pass: md5(this.pass).toUpperCase()
        })
        .then(async r => {
          if (r.data.ok) {
            notify("Excelente!", "success", 2000);
            this.$store.commit("setUser", this.user);
            this.$store.commit("setClave", this.pass);
            sessionStorage.setItem("usuario", this.user);
            sessionStorage.setItem("clave", this.pass);
            await this.obtenerEmpresa();
            this.logged = !this.logged;
          } else {
            notify("Usuario o contraseña invalida", "error", 2000);
          }
        })
        .catch(()=>{
          notify("Error al intentar iniciar sesión", "error", 5000);
          console.error('Error de inicio de sesión. Verificar la conexión con el webservice de PalJetERP')
        });
    },
    async obtenerEmpresa() {
      this.loading = !this.loading;
      await this.axios({
        method: "get",
        url:
          this.$store.getters.ws.api_paljet +
          "/usuarios/" +
          this.user +
          "/empresas",
        headers: {
          EmpID: 1,
          Authorization: "Basic " + btoa(this.user + ":" + this.pass)
        },
        crossDomain: true
      })
        .then(async p => {
          this.empresa = p.data;
          if (p.data.length == 1) {
            this.$store.commit("setEmpId", p.data[0].empId);
            sessionStorage.setItem("empId", p.data[0].empId);
            this.$store.commit("setEmpName", p.data[0].razonSocial);
            sessionStorage.setItem("empName", p.data[0].razonSocial);
            let rol = await this.obtenerRol(p.data[0].empId);
            this.$store.commit("setRol", rol);
            sessionStorage.setItem("rol", rol);
            this.loading = !this.loading;
            this.$router.push({
              name: "articulos",
              params: { lang: this.$i18n.locale }
            });
            notify(
              "Se selecciono la empresa " + p.data[0].razonSocial,
              "info",
              6000
            );
          } else {
            let aux = [];
            for (let empre of this.empresa) {
              if (await this.validarEmpresa(empre.empId)) {
                aux.push(empre);
              }
            }
            this.loading = !this.loading;
            this.empresa = aux;
            if (this.empresa.length == 1) {
              this.$store.commit("setEmpId", this.empresa[0].empId);
              sessionStorage.setItem("empId", this.empresa[0].empId);
              this.$store.commit("setEmpName", this.empresa[0].razonSocial);
              sessionStorage.setItem("empName", this.empresa[0].razonSocial);
              let rol = await this.obtenerRol(this.empresa[0].empId);
              this.$store.commit("setRol", rol);
              sessionStorage.setItem("rol", rol);
              this.$router.push({
                name: "articulos",
                params: { lang: this.$i18n.locale }
              });
              notify(
                "Se selecciono la empresa " + this.empresa[0].razonSocial,
                "info",
                6000
              );
            }
          }
        })
        .catch(() => {
          notify("No se pudo cargar las empresas", "warning", 5000);
        });
    },
    async obtenerRol(id) {
      let rol = await new Promise((resolve) => {
        this.axios
          .get(
            this.$store.getters.ws.api_paljet +
              "usuarios/" +
              this.user +
              "/rol",
            {
              headers: {
                EmpID: id,
                Authorization: "Basic " + btoa(this.user + ":" + this.pass)
              }
            }
          )
          .then(p => {
            if (p.data.nombre != null) {
              resolve(p.data.nombre[0]);
            } else {
              resolve(false);
            }
          })
          .catch(() => {
            resolve(false);
          });
      });
      return rol;
    },
    async validarEmpresa(id) {
      let resp = await new Promise((resolve) => {
        this.axios
          .get(
            this.$store.getters.ws.api_paljet +
              "usuarios/" +
              this.user +
              "/rol",
            {
              headers: {
                EmpID: id,
                Authorization: "Basic " + btoa(this.user + ":" + this.pass)
              }
            }
          )
          .then(p => {
            if (p.data.nombre != null) {
              for (let emp of this.empresa) {
                if (id == emp.empId) {
                  emp.rol = p.data.nombre[0];
                }
              }
              resolve(true);
            } else {
              resolve(false);
            }
          })
          .catch(() => {
            resolve(false);
          });
      });
      return resp;
    },
    seleccionar() {
      if (this.empid != 0 && this.empid != "") {
        this.$store.commit("setEmpId", this.empid);
        sessionStorage.setItem("empId", this.empid);
        let empname = this.empresa.find(p => p.empId == this.empid).razonSocial;
        let rol = this.empresa.find(p => p.empId == this.empid).rol;
        sessionStorage.setItem("empName", empname);
        sessionStorage.setItem("rol", rol);
        this.$store.commit("setEmpName", empname);
        this.$store.commit("setRol", rol);
        this.$router.push({
          name: "articulos",
          params: { lang: this.$i18n.locale }
        });
      } else {
        notify(this.$i18n.t("selectEmp"), "warning", 5000);
      }
    }
  },
  created() {
    if (
      sessionStorage.getItem("usuario") &&
      sessionStorage.getItem("empId") &&
      sessionStorage.getItem("clave") &&
      sessionStorage.getItem("rol") &&
      sessionStorage.getItem("empName")
    ) {
      this.$store.commit("setEmpId", sessionStorage.getItem("empId"));
      this.$store.commit("setEmpName", sessionStorage.getItem("empName"));
      this.$store.commit("setRol", sessionStorage.getItem("rol"));
      this.$store.commit("setUser", sessionStorage.getItem("usuario"));
      this.$store.commit("setClave", sessionStorage.getItem("clave"));
      this.$router.push({
        name: "articulos",
        params: { lang: this.$i18n.locale }
      });
    } else if (
      sessionStorage.getItem("clave") &&
      sessionStorage.getItem("usuario")
    ) {
      this.user = sessionStorage.getItem("usuario");
      this.pass = sessionStorage.getItem("clave");
      //this.verificar();
    }
  }
};
</script>
<style>
#login .btn {
  margin-top: 5px;
}
#login .form-group {
  max-width: 500px;
  margin: 30px auto;
  border: 1px inset grey;
  border-radius: 20px;
  padding: 30px;
  padding-right: 55px;
  box-shadow: 18px 17px 49px 0px;
}
#login .input-group {
  margin: 1em;
}
#login .loading {
  background: transparent !important;
  cursor: progress;
}
.lds-spinner {
  color: black;
  display: block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-spinner div {
  transform-origin: 40px 40px;
  animation: lds-spinner 1.2s linear infinite;
}
.blur {
  filter: blur(4px);
  cursor: progress;
}
.lds-spinner div:after {
  content: " ";
  display: block;
  position: absolute;
  top: 3px;
  left: 37px;
  width: 6px;
  height: 18px;
  border-radius: 20%;
  background: black;
}
.lds-spinner div:nth-child(1) {
  transform: rotate(0deg);
  animation-delay: -1.1s;
}
.lds-spinner div:nth-child(2) {
  transform: rotate(30deg);
  animation-delay: -1s;
}
.lds-spinner div:nth-child(3) {
  transform: rotate(60deg);
  animation-delay: -0.9s;
}
.lds-spinner div:nth-child(4) {
  transform: rotate(90deg);
  animation-delay: -0.8s;
}
.lds-spinner div:nth-child(5) {
  transform: rotate(120deg);
  animation-delay: -0.7s;
}
.lds-spinner div:nth-child(6) {
  transform: rotate(150deg);
  animation-delay: -0.6s;
}
.lds-spinner div:nth-child(7) {
  transform: rotate(180deg);
  animation-delay: -0.5s;
}
.lds-spinner div:nth-child(8) {
  transform: rotate(210deg);
  animation-delay: -0.4s;
}
.lds-spinner div:nth-child(9) {
  transform: rotate(240deg);
  animation-delay: -0.3s;
}
.lds-spinner div:nth-child(10) {
  transform: rotate(270deg);
  animation-delay: -0.2s;
}
.lds-spinner div:nth-child(11) {
  transform: rotate(300deg);
  animation-delay: -0.1s;
}
.lds-spinner div:nth-child(12) {
  transform: rotate(330deg);
  animation-delay: 0s;
}
@keyframes lds-spinner {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>